import autoBind from "auto-bind";
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import Url from "url-parse";

import config from "../../../../../config";
import { isInternalLink } from "../../../../../lib/isInternalLink";

class SquaberLink extends React.Component {
  static propTypes = {
    to: PropTypes.string.isRequired,
    target: PropTypes.string,
    shouldAddSchema: PropTypes.bool,
    forceExternalLink: PropTypes.bool,
    skipScrollToTop: PropTypes.bool
  };

  static defaultProps = {
    target: "_self",
    shouldAddSchema: false
  };

  constructor(props) {
    super(props);

    autoBind.react(this);
  }

  onClick(event) {
    const { to, onClick } = this.props;

    if (to === "#" || to === "#!") {
      event.preventDefault();
    }

    if (onClick) {
      onClick(event);
    }
  }

  getUrl() {
    let { to, shouldAddSchema } = this.props;

    if (
      shouldAddSchema &&
      to.indexOf("http://") === -1 &&
      to.indexOf("https://") === -1
    ) {
      to = `http://${to}`;
    }

    return to;
  }

  isLocalLink() {
    const { target, forceExternalLink } = this.props;

    if (forceExternalLink || (target && target !== "_self")) {
      return false;
    }

    const url = this.getUrl();

    const parsedUrl = new Url(url);

    return parsedUrl.host === config.baseHostName;
  }

  getFormattedUrl() {
    const isInternal = isInternalLink(this.getUrl());
    const url = this.getUrl();

    if (!isInternal || !url) {
      return url;
    }

    const urlParts = url.split("?");
    const lowerCaseUrl = urlParts[0].toLowerCase();
    if (urlParts.length > 1) {
      return lowerCaseUrl + "?" + urlParts[1];
    }
    return lowerCaseUrl;
  }

  stripProtocolAndHostName(url) {
    const parsedUrl = new Url(url);

    return parsedUrl.pathname + parsedUrl.query + parsedUrl.hash;
  }

  render() {
    let {
      to,
      target,
      className,
      children,
      shouldAddSchema,
      skipScrollToTop,
      ...rest
    } = this.props;

    let url = this.getFormattedUrl();

    const isLocalLink = this.isLocalLink();

    if (isLocalLink) {
      url = this.stripProtocolAndHostName(url);
    }

    const parsedUrl = new Url(url);

    return isLocalLink ? (
      <Link
        to={
          skipScrollToTop
            ? {
                pathname: parsedUrl.pathname,
                state: { skipScrollToTop: true },
                hash: parsedUrl.hash,
                search: parsedUrl.query
              }
            : url
        }
        className={className}
        {...rest}
        onClick={this.onClick}
      >
        {children}
      </Link>
    ) : (
      <a
        href={url}
        target={target}
        className={className}
        {...rest}
        onClick={this.onClick}
      >
        {children}
      </a>
    );
  }
}

// Use this adapter whenever you need to embed SquaberLink inside SquaberTooltip
export const AdapterSquaberLink = React.forwardRef((props, ref) => (
  <SquaberLink innerRef={ref} {...props} />
));

export default SquaberLink;
